import React from "react";
import WarehouseImage from "./Images/ab1.jpg"; // replace with your image path
import Logo from "../HomePage/Images/Final2.png"; // replace with your logo path

const AboutSection = () => {
  return (
    <div className="bg-[#e9fbe9] py-16 px-6 md:px-16 lg:px-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* Left Side Content */}
        <div>
          {/* Breadcrumb */}
          <p className="text-sm mb-4 text-gray-700">
            [<span className="text-black">Home</span> /{" "}
            <span className="text-orange-600 font-medium">About</span> ]
          </p>

          {/* Heading */}
          <h1 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">
            Empowering Your Business <br />
            with Smarter Bulk Deals
          </h1>

          {/* Paragraph */}
          <p className="text-gray-700 leading-relaxed">
            At <strong>Daily Go</strong>, we act as the trusted bridge between{" "}
            wholesalers and retailers, making bulk buying simple, reliable, and
            affordable. Our platform connects business owners with genuine
            suppliers offering daily deals on quality products—from pantry
            staples to everyday essentials—so you can focus on growing your
            business with confidence.
          </p>
        </div>

        {/* Right Side Image */}
        <div className="relative">
          <img
            src={WarehouseImage}
            alt="Warehouse"
            className="rounded-xl shadow-md"
          />
          <img
            src={Logo}
            alt="Daily Go Logo"
            className="absolute -bottom-8 -left-8 w-24 h-24 bg-white object-contain rounded-full shadow-lg p-2"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
